import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {groupShape, templateShape} from '../shapes';

export default function NewChecklistModal({onConfirm, onCancel, templates, groups, preselectedTemplateId, defaultGroupId}) {
    const [title, setTitle] = useState('');
    const [templateId, setTemplateId] = useState(preselectedTemplateId || '');
    const [groupId, setGroupId] = useState(defaultGroupId || '');

    // Pre-fill title when a template is selected
    useEffect(() => {
        if (templateId) {
            const tmpl = templates.find(t => t.id === templateId);
            if (tmpl) {
                const date = new Date().toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'});
                setTitle(`${tmpl.name} — ${date}`);
            }
        }
    }, [templateId]); // eslint-disable-line react-hooks/exhaustive-deps

    function submit() {
        const t = title.trim();
        if (!t) return;
        onConfirm(t, templateId || null, groupId || null);
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') submit();
        if (e.key === 'Escape') onCancel();
    }

    return (
        <div
            className="modal-backdrop"
            onClick={onCancel}
            onKeyDown={e => e.key === 'Escape' && onCancel()}
            role="presentation"
        >
            <div
                className="modal"
                onClick={e => e.stopPropagation()}
                onKeyDown={e => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="modal-title">New List</h3>
                {!preselectedTemplateId && templates.length > 0 && (
                    <select
                        className="modal-template-select"
                        value={templateId}
                        onChange={e => setTemplateId(e.target.value)}
                        aria-label="From template"
                    >
                        <option value="">No template</option>
                        {templates.map(t => (
                            <option key={t.id} value={t.id}>{t.name}</option>
                        ))}
                    </select>
                )}
                <input
                    className="modal-input"
                    type="text"
                    placeholder="List title"
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoFocus
                />
                {groups && groups.length > 0 && (
                    <select
                        className="modal-group-select"
                        value={groupId}
                        onChange={e => setGroupId(e.target.value)}
                        aria-label="Group"
                    >
                        <option value="">No group</option>
                        {groups.map(g => (
                            <option key={g.id} value={g.id}>{g.name}</option>
                        ))}
                    </select>
                )}
                <div className="modal-actions">
                    <button className="modal-cancel" onClick={onCancel}>Cancel</button>
                    <button className="modal-confirm" onClick={submit} disabled={!title.trim()}>Create</button>
                </div>
            </div>
        </div>
    );
}

NewChecklistModal.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    templates: PropTypes.arrayOf(templateShape),
    groups: PropTypes.arrayOf(groupShape),
    preselectedTemplateId: PropTypes.string,
    defaultGroupId: PropTypes.string,
};

NewChecklistModal.defaultProps = {
    templates: [],
    groups: [],
    preselectedTemplateId: null,
    defaultGroupId: null,
};
